module.exports = __webpack_public_path__ + "static/scen-2-a6d0ef021de68fc2fd8aadadeafba677.png";